
import React from 'react';

const Alert = ({ type = 'info', message, onClose }) => {
  const types = {
    success: {
      bg: 'bg-green-50',
      border: 'border-green-400',
      text: 'text-green-800',
      icon: '✓',
    },
    error: {
      bg: 'bg-red-50',
      border: 'border-red-400',
      text: 'text-red-800',
      icon: '✕',
    },
    warning: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-400',
      text: 'text-yellow-800',
      icon: '⚠',
    },
    info: {
      bg: 'bg-blue-50',
      border: 'border-blue-400',
      text: 'text-blue-800',
      icon: 'ℹ',
    },
  };

  const style = types[type];

  return (
    <div className={`${style.bg} border-l-4 ${style.border} p-4 rounded-r-lg mb-4`} role="alert">
      <div className="flex items-start">
        <span className={`${style.text} font-bold mr-3 text-lg`}>{style.icon}</span>
        <p className={`${style.text} flex-1`}>{message}</p>
        {onClose && (
          <button
            onClick={onClose}
            className={`${style.text} hover:opacity-75 ml-4`}
            aria-label="Close alert"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default Alert;
